import React from 'react';
import { withRouter } from 'react-router-dom'
import "./Profile.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import FileBase64 from 'react-file-base64';
import store from "../store/index";
import i18n from '../i18n';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';

const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}
class CompanyRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login_name: "",
            password: "",
            lang:'en',
            ctypes:[],
            ctype:'',
            confirmpassword: "",
            company_name: "",
            company_email: "",
            company_contact_no: "",
            company_address: "",
            company_type: "",
            page: 1,
            CR_NO: "",
            document: "",
            errors: {}
        };
        this.register = this.register.bind(this)
        this.getFiles = this.getFiles.bind(this);

    }
    getFiles(file) {
        this.setState({ document: file })
    }
    mySubmitHandler = (event, page) => {

        event.preventDefault();



        let errors = {};
        let formIsValid = true;


        if (page == 2) {
            if (!this.state.login_name) {
                formIsValid = false;
                errors["login_name"] = "Please enter your login name";
            }
            if (!this.state.password) {
                formIsValid = false;

                errors["password"] = "Please enter Password";
            }
            if (!this.state.confirmpassword) {
                formIsValid = false;

                errors["confirmpassword"] = "Please confirm Password";
            }
            if (this.state.confirmpassword != this.state.password) {
                formIsValid = false;
                // alert(this.state.confirmpassword +' '+this.state.password);
                errors["confirmpassword"] = "Passwords do not match";
            }
            this.setState({ errors: errors });
            if (formIsValid) {
                this.setState({ page: 2 });

                console.log("NOW ... You are submitting " + JSON.stringify(this.state));

            } else {
                console.log("Form has errors.")
            }
        }
        else if (page == 3) {
            if (!this.state.company_name) {
                formIsValid = false;

                errors["company_name"] = "Please enter Company Name";
            }
            if (!this.state.company_email) {
                formIsValid = false;

                errors["company_email"] = "Please enter Company Name";
            }
            if (!this.state.company_address) {
                formIsValid = false;

                errors["company_address"] = "Please enter Company Address";
            }
            if (!this.state.CR_NO) {
                formIsValid = false;

                errors["CR_NO"] = "Please enter CR Number";
            }
            if (this.state.document === null || this.state.document.length === 0) {
                formIsValid = false;

                errors["document"] = "Please attach Company Documents";
            }



            this.setState({ errors: errors });
            if (formIsValid) {

                console.log("NOW ... You are submitting " + JSON.stringify(this.state));
                this.setState({ page: 3 });

                //this.handleMembership();

            } else {
                console.log("Form has errors.")
            }
        }
        else {
            this.setState({ page: 1 });
        }

    }
    changePage = (event, pageno) => {

        this.setState({ page: pageno });

    }
    ctChange = (event) => {

        console.log('stad name --- ' + JSON.stringify(event.target.value));


        this.setState({ ctype: event.target.value });
    }
    handleMembership = (event) => {


        event.preventDefault();
        const payload = {

            login_name: this.state.login_name,
            password: this.state.password,
            company_name: this.state.company_name,
            company_email: this.state.company_email,
            company_contact_no: this.state.company_contact_no,
            company_address: this.state.company_address,
            company_type:this.state.ctype,
            CR_NO: this.state.CR_NO,
            document: this.state.document,

        }

        // redirectToHome();
        const mosa = { "mast": payload, ReqHead: headers }
        // console.log('calling api ...' + JSON.stringify(payload));
        let self = this; //  declared var welcom

        console.log('calling api ...' + JSON.stringify(mosa));
        this.setState({ isActive: true });

        axios.post(API_MOSA_URL + '/Company/CompanyRegistration', mosa)
            .then(function (response) {
                console.log(JSON.stringify(response));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {
                    if (response.data[0].StatusCode == "0") {
                        Swal.fire({
                            title: 'Success',
                            text: 'Your membership request is submitted',
                            allowOutsideClick: false,
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                self.props.history.push('/login');


                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }


                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!!!!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });




    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    register = (event, index) => {
        event.preventDefault();
        this.props.history.push('/register');
    }


    componentDidMount() {

        window.scrollTo(0, 0);

        let self = this; //  declared var welcom

        this.setState({ isActive: true });
        const mosa = { ReqHead: headers }
        console.log(JSON.stringify(mosa));


        axios.post(API_MOSA_URL + '/User/CompanyTypeGetList', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ ctypes: response.data[1] });
                        window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }
    render() {
        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });

        let fcs = this.state.ctypes;
        let fcts = fcs.map((fc) =>
            <option value={fc.company_type_mast_id}>{fc.company_type_name_en}</option>
        );
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: '#dfe6e9' }}>

                    <Navbar />
                    <div className="all-title-box">
                        <div className="container text-center">
                            <h1  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK96', this.state.lang)}<span className="m_1">{i18n.t('JK97', this.state.lang)}</span></h1>
                        </div>
                    </div>
                    <section className="testimonial py-3" id="testimonial">
                        <div className="container">
                            <div className="row " style={{backgroundColor:'white'}}>
                                <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                    <div className=" ">
                                        <div className="card-body">
                                            <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />
                                            <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK5', this.state.lang)}</h2>
                                            <p  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK35', this.state.lang)}
                                        </p>
                                            <br />
                                            <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK3', this.state.lang)}</h2>

                                            <p  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK2', this.state.lang)}
                                        </p>
                                            <a className="btn btn-primary" href="/register"  style={{ fontFamily: 'Tajawal' }}><span style={{ color: 'lightgrey' }}>{i18n.t('JK3', this.state.lang)}</span></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 py-5 border">
                                    <div className="card-body" style={{ minHeight: '300px' }}>
                                        {this.state.page == 1 &&
                                            <div className="container">
                                                <div class="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK103', this.state.lang)}</h3>
                                                </div>
                                                <hr />

                                                <div className="form-group row">
                                                    <div className="col  text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK104', this.state.lang)}</label>
                                                        <input
                                                            type="email"
                                                            value={this.state.login_name}
                                                            className={this.state.errors["login_name"] ? "form-control is-invalid" : "form-control"}
                                                            name="login_name"
                                                            placeholder={i18n.t('JK104', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK105', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK182', this.state.lang)}</label>
                                                        <input type="password"
                                                            name="password"
                                                            value={this.state.password}
                                                            className={this.state.errors["password"] ? "form-control is-invalid" : "form-control"}
                                                            placeholder={i18n.t('JK11', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK12', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK107', this.state.lang)}</label>
                                                        <input type="password"
                                                            name="confirmpassword"
                                                            value={this.state.confirmpassword}
                                                            className={this.state.errors["confirmpassword"] ? "form-control is-invalid" : "form-control"}
                                                            placeholder={i18n.t('JK11', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className={this.state.errors["confirmpassword"] ? "form-text text-muted" : "form-text text-muted"}>{i18n.t('JK12', this.state.lang)}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        }
                                        {this.state.page == 2 &&
                                            <div className="container">
                                                <div class="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK106', this.state.lang)}</h3>
                                                </div>
                                                <hr />

                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK108', this.state.lang)}</label>
                                                        <input type="text"
                                                            className={this.state.errors["company_name"] ? "form-control is-invalid" : "form-control"}
                                                            name="company_name"
                                                            value={this.state.company_name}
                                                            placeholder={i18n.t('JK108', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK109', this.state.lang)}</span>
                                                    </div>
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK114', this.state.lang)}</label>
                                                        <input type="email"
                                                            className={this.state.errors["company_email"] ? "form-control is-invalid" : "form-control"}
                                                            name="company_email"
                                                            value={this.state.company_email}
                                                            placeholder={i18n.t('JK114', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK110', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK115', this.state.lang)}</label>
                                                        <input
                                                            type="text"
                                                            className={this.state.errors["CR_NO"] ? "form-control is-invalid" : "form-control"}
                                                            name="CR_NO"
                                                            value={this.state.CR_NO}
                                                            placeholder={i18n.t('JK115', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK111', this.state.lang)}</span>
                                                    </div>
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK116', this.state.lang)}</label>
                                                        <input type="number"
                                                            className={this.state.errors["company_contact_no"] ? "form-control is-invalid" : "form-control"}
                                                            name="company_contact_no"
                                                            value={this.state.company_contact_no}
                                                            placeholder={i18n.t('JK116', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK112', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK117', this.state.lang)}</label>
                                                        <input type="text"
                                                            className={this.state.errors["company_address"] ? "form-control is-invalid" : "form-control"}
                                                            name="company_address"
                                                            value={this.state.company_address}
                                                            placeholder={i18n.t('JK117', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted">{i18n.t('JK113', this.state.lang)}</span>
                                                    </div>
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK183', this.state.lang)}</label>
                                                        <select style={{ width: '100%' }} className="form-control " id="dropdown" onChange={this.ctChange}>
                                                            <option value="N/A">{i18n.t('JK118', this.state.lang)}</option>
                                                            {fcts}
                                                        </select>
                                                        <span className="form-text text-muted"></span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK119', this.state.lang)}</label>
                                                        <div
                                                            className={this.state.errors["document"] ? "form-control is-invalid" : "form-control"}
                                                        >
                                                            <FileBase64
                                                                multiple={false}
                                                                value={this.state}
                                                                onDone={this.getFiles} />
                                                        </div>
                                                        <span className="form-text text-muted">{i18n.t('JK120', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 3 &&
                                            <div className="container">
                                                <div class="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK121', this.state.lang)}</h3>
                                                </div>
                                                <hr />
                                                <div>
                                                    <div className="form-group row">
                                                        <div className="col-md-6 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK104', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.login_name} className="form-control" id="exampleInputEmail1" placeholder="Pincode" />
                                                        </div>
                                                        <div className="col-md-6 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK11', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.password} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK108', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.company_name} className="form-control" id="exampleInputEmail1" placeholder="Pincode" />
                                                        </div>
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK114', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.company_email} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                                        </div>
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK116', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.company_contact_no} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK115', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.CR_NO} className="form-control" id="exampleInputEmail1" placeholder="Pincode" />
                                                        </div>
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK183', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.company_type} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                                        </div>
                                                        <div className="col-md-4 text-left">
                                                            <label htmlFor="exampleInputEmail1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK117', this.state.lang)}</label>
                                                            <input type="text" disabled value={this.state.company_address} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                    <div className="card-footer">
                                        {this.state.page == 1 &&

                                            <div className="row">
                                                <div className="col-lg-6  text-lg-center">


                                                </div>
                                                <div className="col-lg-6 text-lg-center">
                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.mySubmitHandler(e, 2)}>{i18n.t('JK19', this.state.lang)}</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 2 &&

                                            <div className="row">
                                                <div className="col-lg-6  text-lg-center">

                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.mySubmitHandler(e)}>{i18n.t('JK18', this.state.lang)}</button>

                                                </div>
                                                <div className="col-lg-6 text-lg-center">
                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.mySubmitHandler(e, 3)}>{i18n.t('JK19', this.state.lang)}</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 3 &&

                                            <div className="row">
                                                <div className="col-lg-6  text-lg-center">

                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.changePage(e, 2)}>{i18n.t('JK18', this.state.lang)}</button>

                                                </div>
                                                <div className="col-lg-6 text-lg-center">
                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.handleMembership(e)}>{i18n.t('JK122', this.state.lang)}</button>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Footer />
                    {/* <div className="row">
                    <div className="col-md-4 text-center" style={{ paddingRight: '2.5%', paddingLeft: '2.5%', paddingTop: '3%', paddingBottom: '7.5%' }}>
                        <div className="" style={{ backgroundImage: 'url(assets/media/bg/bg-3.jpg)' }}>
                            <div className="">
                                <div className="">
                                    <div className="">
                                        <a href="#">
                                            <img src="http://96.9.130.101:9000/MOSA/assets/media/logos/logo-5.png" alt="" />
                                        </a>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col">
                                            <h3 className="">ALREADY HAVE AN ACCOUNT ?</h3>
                                            <br />
                                            <a href="/login" type="button" id="kt_login_signup" className="btn btn-outline-primary btn-pill py-4 px-9 font-weight-bold">Login Now</a>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <div className="col">

                                            <h3 className="">ARE YOU JOINING FOR PERSONAL USE ?</h3>
                                            <br />
                                            <a href="/register" type="button" id="kt_login_signup" className="btn btn-outline-primary btn-pill py-4 px-9 font-weight-bold">Individual Registration</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 text-center" style={{ padding: '40px', backgroundImage: 'url(assets/media/bg/bg-5.jpg)' }}>

                        <div className="card card-custom gutter-b">
                            <div className="card-header" style={{ padding: '15px' }}>
                                <div className="text-center">
                                    <h2 className="font-weight-bold">Company Registration</h2>
                                    <p className="text-muted font-weight-bold">Register now in three simple steps.</p>
                                </div>
                                <ul className="nav nav-pills" id="myTab1" role="tablist">
                                    <li className="nav-item">
                                        <a className={this.state.page == 1 ? "nav-link active" : "nav-link "}>
                                            <span className="nav-icon">
                                                <i className="flaticon2-user-1" />
                                            </span>
                                            <span className="nav-text">Step 1 . Add Login</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={this.state.page == 2 ? "nav-link active" : "nav-link "}>
                                            <span className="nav-icon">
                                                <i className="flaticon2-layers-1" />
                                            </span>
                                            <span className="nav-text">Step 2 .Company Info</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={this.state.page == 3 ? "nav-link active" : "nav-link "} id="contact-tab-1" data-toggle="tab" href="#contact-1" aria-controls="contact">
                                            <span className="nav-icon">
                                                <i className="flaticon2-rocket-1" />
                                            </span>
                                            <span className="nav-text">Step 3 . Review and Submit</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-body">
                                {this.state.page == 1 &&
                                    <div className="container">
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Login Name</label>
                                                <input
                                                    type="email"
                                                    value={this.state.login_name}
                                                    className={this.state.errors["login_name"] ? "form-control is-invalid" : "form-control"}
                                                    name="login_name"
                                                    placeholder="Enter Login Name"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please enter your login username</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Set Password</label>
                                                <input type="password"
                                                    name="password"
                                                    value={this.state.password}
                                                    className={this.state.errors["password"] ? "form-control is-invalid" : "form-control"}
                                                    placeholder="Enter Password"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please enter password</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Confirm Password</label>
                                                <input type="password"
                                                    name="confirmpassword"
                                                    value={this.state.confirmpassword}
                                                    className={this.state.errors["confirmpassword"] ? "form-control is-invalid" : "form-control"}
                                                    placeholder="Enter Password"
                                                    onChange={this.myChangeHandler} />
                                                <span className={this.state.errors["confirmpassword"] ? "form-text text-muted" : "form-text text-muted"}>{!this.state.errors["confirmpassword"] ? "Please confirm password" : this.state.errors["confirmpassword"]}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.state.page == 2 &&
                                    <div className="container">
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Company Name</label>
                                                <input type="text"
                                                    className={this.state.errors["company_name"] ? "form-control is-invalid" : "form-control"}
                                                    name="company_name"
                                                    value={this.state.company_name}
                                                    placeholder="Enter Company Name"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please your company name</span>
                                            </div>
                                            <div className="col-lg-6">
                                                <label>Company Email</label>
                                                <input type="email"
                                                    className={this.state.errors["company_email"] ? "form-control is-invalid" : "form-control"}
                                                    name="company_email"
                                                    value={this.state.company_email}
                                                    placeholder="Enter Company Email"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please your company email</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Company CR Number</label>
                                                <input
                                                    type="text"
                                                    className={this.state.errors["CR_NO"] ? "form-control is-invalid" : "form-control"}
                                                    name="CR_NO"
                                                    value={this.state.CR_NO}
                                                    placeholder="Enter CR Number"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please your company CR Number</span>
                                            </div>
                                            <div className="col-lg-6">
                                                <label>Company Contact</label>
                                                <input type="number"
                                                    className={this.state.errors["company_contact_no"] ? "form-control is-invalid" : "form-control"}
                                                    name="company_contact_no"
                                                    value={this.state.company_contact_no}
                                                    placeholder="Enter Contact"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please your company contact</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-lg-6">
                                                <label>Company Address</label>
                                                <input type="text"
                                                    className={this.state.errors["company_address"] ? "form-control is-invalid" : "form-control"}
                                                    name="company_address"
                                                    value={this.state.company_address}
                                                    placeholder="Enter Company Address"
                                                    onChange={this.myChangeHandler} />
                                                <span className="form-text text-muted">Please your company address</span>
                                            </div>
                                            <div className="col-lg-6">
                                                <label>Company Document</label>
                                                <div
                                                    className={this.state.errors["document"] ? "form-control is-invalid" : "form-control"}
                                                >
                                                    <FileBase64
                                                        multiple={false}
                                                        onDone={this.getFiles} />
                                                </div>
                                                <span className="form-text text-muted">Please upload company document</span>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className="card-footer">
                                {this.state.page == 1 &&
                                    <div className="row">
                                        <div className="col-lg-6  text-lg-center">


                                        </div>
                                        <div className="col-lg-6 text-lg-center">
                                            <button type="reset" className="btn btn-success mr-2" style={{ width: '50%' }} onClick={e => this.mySubmitHandler(e, 2)}>Next</button>
                                        </div>
                                    </div>
                                }
                                {this.state.page == 2 &&
                                    <div className="row">
                                        <div className="col-lg-6  text-lg-center">

                                            <button type="reset" className="btn btn-info mr-2" style={{ width: '50%' }} onClick={e => this.mySubmitHandler(e)}>Previous</button>

                                        </div>
                                        <div className="col-lg-6 text-lg-center">
                                            <button type="reset" className="btn btn-success mr-2" style={{ width: '50%' }} onClick={e => this.mySubmitHandler(e, 3)}>Submit</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                   
                    </div>

                </div> */}
                </div>
            </LoadingOverlay>
        )
    }
}
export default withRouter(CompanyRegister);
